import { create } from "zustand";
import _get from "lodash/get";
import { api } from "network/network";
import { API_HOST_WMS } from "config/api.config";
import { APIendpoints } from "utils/constants/APIendpoints";
import {
  STATUS_BEGIN,
  STATUS_DONE,
  STATUS_FAIL,
} from "utils/constants/others";
import { makeEncodedQueryParams } from "operations/operations";

const buildQuery = (params) => {
  const parts = [];
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value === undefined || value === null || value === "") return;
    parts.push(`${key}=${encodeURIComponent(value)}`);
  });
  return parts.length ? `?${parts.join("&")}` : "";
};

const usePayoutsStore = create((set, get) => ({
  accruals: [],
  accrualsStatus: "",
  accrualsRequestId: 0,
  accrualsHasMore: true,
  transactions: [],
  transactionsStatus: "",
  transactionsRequestId: 0,
  transactionsHasMore: true,

  getVendorAccruals: async (params, { append = false } = {}) => {
    const requestId = get().accrualsRequestId + 1;
    set({
      accruals: append ? get().accruals : [],
      accrualsStatus: STATUS_BEGIN,
      accrualsRequestId: requestId,
      accrualsHasMore: append ? get().accrualsHasMore : true,
    });
    const url = `${APIendpoints.getVendorAccruals}${buildQuery(params)}`;
    try {
      const response = await api.get(API_HOST_WMS, url);
      if (get().accrualsRequestId !== requestId) return;
      const list = _get(response, ["data", "response", "accrual_details"], []);
      const pageSize = Number(params.page_size) || list.length;
      set({
        accruals: append ? [...get().accruals, ...list] : list,
        accrualsStatus: STATUS_DONE,
        accrualsHasMore: list.length >= pageSize,
      });
    } catch (error) {
      if (get().accrualsRequestId !== requestId) return;
      set({
        accruals: append ? get().accruals : [],
        accrualsStatus: STATUS_FAIL,
        accrualsHasMore: false,
      });
    }
  },

  getVendorTransactions: async (params, { append = false } = {}) => {
    const requestId = get().transactionsRequestId + 1;
    set({
      transactions: append ? get().transactions : [],
      transactionsStatus: STATUS_BEGIN,
      transactionsRequestId: requestId,
      transactionsHasMore: append ? get().transactionsHasMore : true,
    });
    const url = `${APIendpoints.getVendorTransactions}${buildQuery(params)}`;
    try {
      const response = await api.get(API_HOST_WMS, url);
      if (get().transactionsRequestId !== requestId) return;
      const list = _get(
        response,
        ["data", "response", "entity_transaction_details"],
        []
      );
      const pageSize = Number(params.page_size) || list.length;
      set({
        transactions: append ? [...get().transactions, ...list] : list,
        transactionsStatus: STATUS_DONE,
        transactionsHasMore: list.length >= pageSize,
      });
    } catch (error) {
      if (get().transactionsRequestId !== requestId) return;
      set({
        transactions: append ? get().transactions : [],
        transactionsStatus: STATUS_FAIL,
        transactionsHasMore: false,
      });
    }
  },

  resetAccruals: () =>
    set((state) => ({
      accruals: [],
      accrualsStatus: "",
      accrualsRequestId: state.accrualsRequestId + 1,
      accrualsHasMore: true,
    })),

  resetTransactions: () =>
    set((state) => ({
      transactions: [],
      transactionsStatus: "",
      transactionsRequestId: state.transactionsRequestId + 1,
      transactionsHasMore: true,
    })),

  resetPayouts: () =>
    set((state) => ({
      accruals: [],
      accrualsStatus: "",
      accrualsRequestId: state.accrualsRequestId + 1,
      accrualsHasMore: true,
      transactions: [],
      transactionsStatus: "",
      transactionsRequestId: state.transactionsRequestId + 1,
      transactionsHasMore: true,
    })),
}));

export { makeEncodedQueryParams };
export default usePayoutsStore;
